/**
 * Deployed / runtime environment string from the Vite build.
 * Playwright builds alias this module to allow a per-spec override.
 */
export function getRuntimeEnvironment(): string {
    return import.meta.env.VITE_ENVIRONMENT;
}
